import Vue from "vue";
import { configure, extend, ValidationProvider, ValidationObserver } from "vee-validate";
import i18n from "../i18n";
import { email, required, min } from "vee-validate/dist/rules";

configure({ classes: { valid: "parsley-success", invalid: "parsley-error" }});
configure({
    defaultMessage: (field, values) => i18n.t(`VeeValidate.${values._rule_}`, values),
});
extend("required", required);
extend("email", email);
extend("min", min);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);